















import { Component, Prop, Vue } from 'vue-property-decorator';
import { CardsConfig } from '@/type/CardsConfig';

import CardItem from './CardItem.vue';

@Component({
  components: {
    CardItem
  }
})
export default class CardBlock extends Vue {
  @Prop() private quantity!: number;
  @Prop() private region!: string;
  @Prop() private cardData!: CardsConfig[];

  get regionClass(): string {
    return `card-group--${this.region}`;
  }

  get cardsArray() {
    let array: CardsConfig[][] = [];

    for (let i = 0, l = this.quantity; i < l; i++) array.push([]);

    if (!this.cardData) return;
    this.cardData.forEach((obj: CardsConfig, id: number) => {
      array[id % 8].push(obj);
    });
    return array;
  }

  mouseenterHandler(data: string) {
    // console.log(data)
  }
}
